import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { AnimatedBackground } from "@/components/AnimatedBackground";
import { ScrollProgress } from "@/components/ScrollProgress";
import { Analytics } from "@/components/Analytics";
import { GoogleTag } from "@/components/GoogleTag";
import { LiveBanner } from "@/components/LiveBanner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";
import Privacy from "@/pages/Privacy";
import Termini from "@/pages/Termini";
import UsoLecito from "@/pages/UsoLecito";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Layout = () => (
  <div className="relative min-h-screen flex flex-col bg-background text-foreground">
    <ScrollProgress />
    <AnimatedBackground />
    <Navbar />
    <main className="flex-1">
      <Outlet />
    </main>
    <LiveBanner />
    <Footer />
    <WhatsAppButton />
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <CartProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollManager />
            <Analytics />
            <GoogleTag />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/success" element={<Success />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/termini" element={<Termini />} />
                <Route path="/uso-lecito" element={<UsoLecito />} />
                <Route path="/admin" element={<Admin />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
        </div>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
